import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RouterState } from 'connected-react-router';

import { AppState } from 'pages';
import { AllPlanDispLink } from 'pages/plan-list/components/AllPlanDispLink';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { SasPagePath } from 'common/utils/urls';

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const dispatch = useDispatch();
  /** routerStateからクエリパラメータを取得する */
  const routerState = useSelector<AppState, RouterState>(
    (state) => state.app.router
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );

  const _searchParams = new URLSearchParams(routerState.location.search);
  const _dsipFlag = _searchParams.get('serviceId') ? true : false;

  /** 「< 全ての商品を表示する」 クリック時の処理 */
  const onClickAllPlan = () => {
    // サービスID指定無しとしてプラン情報一覧画面を再描画する
    window.location.href = `${SasPagePath.PlanList}`;
  };

  return {
    show: _dsipFlag,
    onClickAllPlan: onClickAllPlan,
    glossary: Glossary.instance(glState)
  };
};

/**
 * プランリストに表示する全ての商品を表示用LinxTextのContainer Component
 */
export default function ContainerComponent() {
  const _props = useStateProps();
  return <AllPlanDispLink {..._props} />;
}
